import { render, staticRenderFns } from "./BaseStoreFile.vue?vue&type=template&id=156f124c"
import script from "./BaseStoreFile.vue?vue&type=script&lang=js"
export * from "./BaseStoreFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports